import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import labels from "../../../config/labels";
import { setNumberTransferDetails } from "../../../Redux/actions/checkoutAction";
import * as Analytics from "../../../services/analyticsUtag";
import ajaxServices from "../../../utils/ajaxServices";
import { imagePrefix } from "../../../utils/helperServices";
import { CustomContainer, Image, Form } from "../../atoms/DependencyHelper";
import { NumberTransferCBU } from "../../organisms/NumberTransfer/NumberTransfer";

import styles from "./numberTransferTypes.module.scss";
import formStyles from "../../atoms/staticForms/StaticForms.module.scss";


const GeneralInfoBox = ({onChangeHandler}) => {
  const { multicartFlag } = useContext(NumberTransferCBU);

  const sendAnalitycsLink = (additionalInfo) => {
    Analytics.link({
      ...Analytics.getUtagData([
        "page_name",
        "page_channel",
        "page_master_tab",
        "page_channel",
        "page_master_tab",
        "visitor_login_status",
        "visitor_customer_id",
        "visitor_id_hash",
        "visitor_msisdn_hash",
        "visitor_subscription_type",
      ]),
      link_type: "o",
      ...additionalInfo,
    });
  };
  const [message, setMessage] = useState({
    icon: "",
    title: "",
    description: "",
  });
  const [isChecked, setIsChecked] = useState(false);
  const details = useSelector(
    ({ checkoutDetails }) => checkoutDetails.numberTransferDetails
  );
  const number = useSelector(
    ({ checkoutDetails }) => checkoutDetails.numberToTransfer
  );
  const dispatch = useDispatch();
  const tryAnother = () => {
    setMessage({
      icon: "",
      title: "",
      description: "",
    });
    dispatch(setNumberTransferDetails({}));
    sendAnalitycsLink({
      link_name: "checkout: number transfer: use another number",
      link_type: "o",
    });
  };
  useEffect(() => {
    if (details?.success) {
      Analytics.view({
        page_event: "view",
        multicart_flag: multicartFlag ? true : false,
        page_name: "checkout: number transfer: success",
        ...Analytics.getUtagData([
          "page_channel",
          "page_master_tab",
          "visitor_login_status",
          "visitor_customer_id",
          "visitor_id_hash",
          "visitor_msisdn_hash",
          "visitor_subscription_type",
        ]),
      });
      ajaxServices
        .httpGet("drupalBaseUrl", "", "api", "errorResultDetails", [
          "OTP Successful",
        ])
        .then(([response]) => {
          setMessage({
            icon: "icon-sucess",
            title: response?.resultTitle?.replace(
              "{customer number}",
              [number.slice(0, 3), "****", number.slice(-3)].join("")
            ),
            description: response.resultText,
          });
        })
        .catch(() => {
          setMessage({
            icon: "icon-sucess",
            title:
              "Great! We’ll transfer {customer number} to this contract".replace(
                "{customer number}",
                [number.slice(0, 3), "****", number.slice(-3)].join("")
              ),
            description:
              "We’ll begin the number transfer process once this application has been successfully submitted.",
          });
        });
    } else {
      if (details.errorType) {
        ajaxServices
          .httpGet("drupalBaseUrl", "", "api", "errorResultDetails", [
            details.errorType
          ])
          .then(([response]) => {
            setMessage({
              icon: "lock",
              title: response?.resultTitle,
              description: response?.resultHTML,
            });
          })
          .catch(() => {
            setMessage({
              icon: "lock",
              title: "This number cannot be used for your new contract",
              description:
                "We see that the number you've entered is already being used on a Vodacom contract. We can only transfer a prepaid number to your new contract. You can continue completing your application and get a new number, or you can try transferring another prepaid number.",
            });
          });
      } else {
        setMessage({
          icon: "lock",
          title: "Your prepaid number cannot be transferred right now",
          description:
            "We see there is currently an existing request to transfer this number to another contract. Until this request has been resolved and 30 days have passed, we cannot use this number.<br /><br />You can continue completing your application and get a new number, or you can try transferring another prepaid number.",
        });
      }
    }
  }, [details]);

  if (!details || !message.icon) {
    return null;
  }

  window.scrollTo(0, 0);

  const handleChange = (event) => {
    setIsChecked(!isChecked);
    onChangeHandler(!isChecked);
  };

  return (
    <div className={styles["number-transfer-general-info__box"]}>
      <Image
        src={`${imagePrefix}/assets/images/${message.icon}.svg`}
        className={styles["number-transfer-general-info__icon"]}
      />
      <div className={styles["number-transfer-general-info__title"]}>
        {message.title}
      </div>
      <div
        className={styles["number-transfer-general-info__description"]}
        dangerouslySetInnerHTML={{ __html: message.description }}
      />
      {details?.errorType === "Number_not_validated" &&
      <>
        <CustomContainer className={`${formStyles["main-container"]}`}>
          <Form.Row className={`${formStyles["main-row"]} ${formStyles["full-row"]} p-0`}>
            <Form.Group className={`${styles["contact_container"]}`}>
              <Form.Check
                custom
                className={`${formStyles["form-checkbox-label"]}`}
              >
                <Form.Check.Input
                  name="contactMe"
                  type="checkbox"
                  onChange={handleChange}
                  checked={isChecked}
                />

                <Form.Check.Label id={`contact_container-label`}>
                  <span>Yes, I’d like a consultant to contact me to finalise my number transfer</span>
                </Form.Check.Label>
              </Form.Check>
            </Form.Group>
          </Form.Row>
        </CustomContainer>
      </>
      }
      <button
        className={styles["number-transfer-general-info__button"]}
        onClick={() => tryAnother()}
      >
        {details?.success
          ? labels.lbl_transfer_number.lbl_retry_button2
          : labels.lbl_transfer_number.lbl_retry_button}
        <i className={styles["number-transfer-general-info__arrow"]} />
      </button>
    </div>
  );
};

GeneralInfoBox.propTypes = {
  onChangeHandler: PropTypes.func
};

export default GeneralInfoBox;
